import { getDeep } from '@shared/utils/getDeep.js';
import { randomId } from '@shared/utils/randomId.js';
import { setDeep } from '@shared/utils/setDeep.js';
import { store } from '../../../../redux/lib/configureStore';
import workflowScreenSelectors from '../selectors/workflowScreenSelectors';
import { action } from '@/lib/api.js';
import selectors from '@/redux/selectors/selectors.js';
import pushChangesQueueItem from '@/redux/actions/pushChangesQueueItem.js';

const appIssueActions = {
  set(path, payload, opts) {
    return new Promise((resolve) => {
      if (!opts?.issueId) {
        console.error('Issue ID is required');
        return;
      }

      const state = store.getState();
      const issue = selectors.issueById(state, opts.issueId);
      const newIssue = setDeep(issue, path, payload);
      const value = getDeep(path, newIssue);

      action('PUT_ISSUE', { data: [newIssue] });
      pushChangesQueueItem('issue', { issueId: newIssue?.id, path, value });
      resolve(newIssue);
    });
  },

  create({ message, isRelatedToAction }) {
    return new Promise(async (resolve) => {
      const state = store.getState();
      const userId = selectors.userId(state);
      const stepApp = workflowScreenSelectors.activeWorkflowStepApp(state);
      const stepAppAction = workflowScreenSelectors.activeWorkflowStepAppAction(state);

      const newIssue = {
        id: randomId(12, 'all'),
        appId: stepApp?.id,
        appVersion: stepApp?.version,
        actionId: isRelatedToAction && stepAppAction?.id ? stepAppAction?.id : undefined,
        message,
        createdOn: new Date(),
        createdBy: userId
      };

      action('POST_ISSUE', { data: [newIssue] });
      pushChangesQueueItem('issue', { operation: 'add', issueId: newIssue?.id, value: newIssue });
      resolve(newIssue);
    });
  }
};

export default appIssueActions;
